export default "__VITE_ASSET__D3EITH_x__"